import { DOCUMENT } from '@angular/common';
import { inject, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';

import { provideUrlActionTriggerRoute } from './provide-url-action-trigger-route';
import { interceptUrlActionTriggerLink } from './url-action-trigger-interceptor';
import { UrlActionTrigger } from './url-action-trigger.types';

export const provideUrlActionTrigger = (
  handlersMap: Record<UrlActionTrigger, Function>,
  interceptClicks: boolean = true, // can be set to false if HashLocationStrategy is used
) =>
  provideAppInitializer(() => {
    const initializerFn = (() => {
      const router = inject(Router);
      const doc = inject(DOCUMENT);
      const route = provideUrlActionTriggerRoute(handlersMap);

      router.resetConfig([route, ...router.config]);

      if (interceptClicks) {
        interceptUrlActionTriggerLink(doc, router);
      }

      return () => void 0;
    })();
    return initializerFn();
  });
